import { render, staticRenderFns } from "./DollarIcon.vue?vue&type=template&id=0094c09a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0094c09a')) {
      api.createRecord('0094c09a', component.options)
    } else {
      api.reload('0094c09a', component.options)
    }
    module.hot.accept("./DollarIcon.vue?vue&type=template&id=0094c09a", function () {
      api.rerender('0094c09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DollarIcon.vue"
export default component.exports